import { useCallback } from "react";
import { InspectionInfo } from "../../models/workorders/Inspection";
import { saveInspection } from "../../models/inspections/Inspections";
import { removeInspectionFromLocal } from "../../util/InspectionsHelper";

export default function useCompleteInspection() {
  const completeInspection = useCallback(async (inspection: InspectionInfo) => {
    const {
      checkOverride,
      comments,
      currentTestEquip,
      inspectionDefinition,
      inspectionId,
      pointVals,
      woNumber,
    } = inspection;
    const response = await saveInspection(
      woNumber,
      inspectionId,
      pointVals,
      inspectionDefinition,
      checkOverride,
      comments,
      currentTestEquip
    );
    if (!response.isError)
      // Remove inspection from local storage if present
      await removeInspectionFromLocal(inspectionId, woNumber);
    return response;
  }, []);

  return { completeInspection };
}
